export class Declarations {
  occupyProperty: boolean | undefined;
  havePropertiesOwnership: boolean   | undefined;
  typeOfProperty: string | undefined;
  heldTitleHow: string | undefined;
  haveRelationshipWithSeller: boolean  | undefined;
  borrowedDownPayment: boolean  | undefined;
  borrowedDownPaymentInfo:number | undefined;
  applyingForOtherMortgage: boolean  | undefined;
  applyingForNonMortgageCredit: boolean  | undefined;
  propertyHasLienWithCleanEnergyProgram: boolean  | undefined;
  coSignedLoan: boolean  | undefined;
  haveJudgement: boolean | undefined;
  haveTaxDebt: boolean  | undefined;
  haveLawsuit: boolean  | undefined;
  haveConveyedTitleInLieuOfForeclosure: boolean | undefined;
  haveCompletedShortSale: boolean  | undefined;
  beenForclosed: boolean  | undefined;
  declaredBankruptcy: boolean  | undefined;
  bankruptcyType:string | undefined;
  residenceStatus:string | undefined | null = null;
  undisclosedMoneyAmount: number | undefined;
  explanations: DeclarationExplanation[] = [];

  constructor() {
    this.residenceStatus = null;
  }
}

export interface DeclarationExplanation {
  description: string;
  explanationType: DeclarationExplanationType;
  explanationTypeOtherDescription?: string;
}

export enum DeclarationExplanationType {
  BorrowedDownPayment = 'BorrowedDownPayment',
  CoMakerEndorserOnNote = 'CoMakerEndorserOnNote',
  OutstandingJudgments = 'OutstandingJudgments',
  DelinquencyOrDefault = 'DelinquencyOrDefault',
  PartyToLawsuit = 'PartyToLawsuit',
  ObligatedOnLoanForeclosedOrDeedInLieuOfJudgment = 'ObligatedOnLoanForeclosedOrDeedInLieuOfJudgment',
  Other = 'Other',
  DirectIndirectForeclosedPropertyPastSevenYears = 'DirectIndirectForeclosedPropertyPastSevenYears',
  DeclaredBankruptcyPastSevenYears = 'DeclaredBankruptcyPastSevenYears',
}
